import $ from "jquery";
import RiderIncentives from "../Finance/RiderIncentives";

export var BaseUrlAPI = process.env.REACT_APP_API_URL;

export var RolesEnum = {
	Admin: 1,
	XpertSiteUser: 3,
	Rider: 4,
	DistrictFieldSupervisor: 5,
	BHUUser: 6,
	RHCUser: 7,
	SRAdmin: 8,
};
export var DeliveryStatus = {
	Pending: 1,
	Accepted: 2, // not used
	PickedUp: 3,
	Delivered: 4,
	Tested: 5,
};
export var MTBResultStatus = {
	Invalid: 1,
	Detected: 2,
	NotDetected: 3,
	Error: 4,
};
export var RRResultStatus = {
	Invalid: 1,
	Detected: 2,
	NotDetected: 3,
	Indeterminate: 4,
};
export var AFBResultStatus = {
	Negative: 1,
	Positive: 2,
};
export var AFBResultStatusType = {
	Scanty: 1,
	OnePlus: 2,
	TwoPlus: 3,
	ThreePlus: 4,
};
export var HCFType = {
	BHU: 1,
	RHC: 2,
};
export var ClusterType = {
	BHUCluster: 1,
	RHCCluster: 2,
};
export var destinationTypes = {
	BHU: 1,
	RHC: 2,
	XpertSite: 3,
};
export var AssignmentStatus = {
	Pending: 1,
	Accepted: 2,
	Started: 3,
	Completed: 4,
	parkedforComplete: 5,
};
export var samplePurpose = {
	Delivery: 1,
	Test: 2,
};
export var DashboardReportsGetType = {
	Admin: 1,
	SRAdmin: 2,
	BHU: 3,
	RHC: 4,
	XpertSite: 5,
};
export var genderEnum = {
	Male: 1,
	Female: 2,
	Other: 3,
};

export function encodeImgtoBase64(element, callback) {
	if ($("#" + element)[0].files && $("#" + element)[0].files[0]) {
		var FR = new FileReader();
		FR.addEventListener("load", (e) => {
			callback(e.target.result);
		});
		FR.readAsDataURL($("#" + element)[0].files[0]);
	} else {
		callback("");
	}
}
export function AddClassToMenueLink(linkId, IsChild = false, parentId = "") {
	$(".UserTopMenu").removeClass("ActiveUserOption");
	$(".mainlayoutlinks").removeClass("activemainlink");
	if (IsChild === false) {
		$("#" + linkId).addClass("activemainlink");
		$("#" + linkId + " > a > span.imageContainer > .basic_image").hide();
		$("#" + linkId + " > a > span.imageContainer > .active_image").show();
		// $("#"+linkId+" i").addClass("activemainlink")
	} else {
		$("#" + parentId).addClass("show");
		$("#" + linkId).addClass("activemainlink");
		$("#" + parentId + " > ul").addClass("show");
		$("#" + parentId + " > a > span.imageContainer > .basic_image").hide();
		$("#" + parentId + " > a > span.imageContainer > .active_image").show();
	}
}
export function ConvertToUtcDateTime(DateTimeObj) {
	const moment = require("moment-timezone");
	var tempDate = new Date(DateTimeObj);
	return moment(tempDate).utc().format("DD/MMM/YYYY HH:mm:ss ");
}

export function ConvertToUtcDateTimeNew(DateTimeObj) {
	if (DateTimeObj === null) {
		return "";
	}

	const moment = require("moment-timezone");
	var tempDate = new Date(DateTimeObj);
	return moment(tempDate).format("DD/MMM/YYYY HH:mm:ss ");
}
export function getOnlyDate(dateObject) {
	// return timeZoneParameter
	var DateTemp = new Date(dateObject);
	var day = ("0" + DateTemp.getDate()).slice(-2);
	var month = ("0" + (DateTemp.getMonth() + 1)).slice(-2);
	return month + "/" + day + "/" + DateTemp.getFullYear();
}

export function ConvertToLocalDateTime(DateTimeObj) {
	//debugger;
	if (DateTimeObj) {
		const moment = require("moment-timezone");
		var DateTimeMmoment = moment.utc(
			moment(DateTimeObj).format("DD/MMM/YYYY hh:mm:ss A")
		);
		DateTimeMmoment = DateTimeMmoment.local();
		return DateTimeMmoment.format("MMM DD, YYYY hh:mm A");
	}
	return "";
}

export function ConvertToLocalDate(DateTimeObj) {
	//debugger;
	if (DateTimeObj) {
		const moment = require("moment-timezone");
		var DateTimeMmoment = moment.utc(
			moment(DateTimeObj).format("DD/MMM/YYYY hh:mm:ss A")
		);
		DateTimeMmoment = DateTimeMmoment.local();
		return DateTimeMmoment.format("MMM DD, YYYY");
	}
	return "";
}

export function ConvertToLocalTime(DateTimeObj) {
	//debugger;
	if (DateTimeObj) {
		const moment = require("moment-timezone");
		var DateTimeMmoment = moment.utc(
			moment(DateTimeObj).format("DD/MMM/YYYY hh:mm:ss A")
		);
		DateTimeMmoment = DateTimeMmoment.local();
		return DateTimeMmoment.format("hh:mm A");
	}
	return "";
}

export function ToggleAccordian(e) {
	e.currentTarget.classList.toggle("active");
	var panel = e.currentTarget.nextElementSibling;
	if (panel.style.maxHeight) {
		panel.style.maxHeight = null;
	} else {
		panel.style.maxHeight = panel.scrollHeight + "px";
	}
}
export function parseJwt(token, ResponseFun) {
	var base64Url = token.split(".")[1];
	var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
	var jsonPayload = decodeURIComponent(
		atob(base64)
			.split("")
			.map(function (c) {
				return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join("")
	);

	ResponseFun(JSON.parse(jsonPayload));
}
export function GetUserPermissions(Permissions, ScreenName, Call_back) {
	var lst = [];
	for (var i = 0; i < Permissions.length; i++) {
		var array = Permissions[i].permissionName.split("-");
		if (array[0] === ScreenName) {
			lst.push(array[1]);
		}
	}
	Call_back(lst);
}
export function GetId() {
	var URL = window.location.href;
	// var URL = $(location).attr("href");
	var URL_ARRAY = URL.split("/");
	var Id = parseInt(URL_ARRAY[URL_ARRAY.length - 1]);

	return isNaN(Id) ? 0 : Id;
}
export function isEmptyUndef(str) {
	return !str || 0 === str.length;
}
export function getAge(date) {
	var now = new Date();
	var today = new Date(now.getYear(), now.getMonth(), now.getDate());

	var yearNow = now.getYear();
	var monthNow = now.getMonth();
	var dateNow = now.getDate();

	var dob = new Date(date);
	var yearDob = dob.getYear();
	var monthDob = dob.getMonth();
	var dateDob = dob.getDate();
	var age = {};
	var ageString = "";
	var yearString = "";
	var monthString = "";
	var dayString = "";

	var yearAge = yearNow - yearDob;

	if (monthNow >= monthDob) var monthAge = monthNow - monthDob;
	else {
		yearAge--;
		var monthAge = 12 + monthNow - monthDob;
	}

	if (dateNow >= dateDob) var dateAge = dateNow - dateDob;
	else {
		monthAge--;
		var dateAge = 31 + dateNow - dateDob;

		if (monthAge < 0) {
			monthAge = 11;
			yearAge--;
		}
	}

	age = {
		years: yearAge,
		months: monthAge,
		days: dateAge,
	};

	if (age.years > 1) yearString = " years";
	else yearString = " year";
	if (age.months > 1) monthString = " months";
	else monthString = " month";
	if (age.days > 1) dayString = " days";
	else dayString = " day";

	if (age.years > 0 && age.months > 0 && age.days > 0)
		ageString =
			age.years +
			yearString +
			", " +
			age.months +
			monthString +
			" and " +
			age.days +
			dayString +
			" old";
	else if (age.years === 0 && age.months === 0 && age.days > 0)
		ageString = age.days + dayString + " old";
	else if (age.years > 0 && age.months === 0 && age.days === 0)
		ageString = age.years + yearString + " old";
	else if (age.years > 0 && age.months > 0 && age.days === 0)
		ageString =
			age.years + yearString + " and " + age.months + monthString + " old";
	else if (age.years === 0 && age.months > 0 && age.days > 0)
		ageString =
			age.months + monthString + " and " + age.days + dayString + " old";
	else if (age.years > 0 && age.months === 0 && age.days > 0)
		ageString =
			age.years + yearString + " and " + age.days + dayString + " old";
	else if (age.years === 0 && age.months > 0 && age.days === 0)
		ageString = age.months + monthString + " old";
	else ageString = "Oops! Could not calculate age!";

	// return ageString ;

	var CategoyRange = "";
	if (age.years === 0 || (age.years > 0 && age.years <= 5))
		CategoyRange = "0-5";
	else if (age.years >= 6 && age.years <= 12) CategoyRange = "6-12";
	else if (age.years >= 13 && age.years <= 17) CategoyRange = "13-17";
	else if (age.years >= 18) CategoyRange = "Above 18";

	return { Age: ageString, AgeCategory: CategoyRange };
}
export function ProcessDataInArray(lst, fieldName = "id") {
	var tempLst = [];
	for (var i in lst) {
		tempLst[lst[i][fieldName]] = lst[i];
	}
	return tempLst;
}
export function paginate(array, page_size, page_number) {
	return array.slice((page_number - 1) * page_size, page_number * page_size);
}
export function convertToCommaString(array, AttributeName) {
	var temp = "";
	for (var i = 0; i < array.length; i++) {
		temp += "," + array[i][AttributeName];
	}
	return temp.substr(1);
}
export function Print(ContainerId) {
	// if ($("#SaleInvoice5Inch").children().length > 0) {
	//var left = (screen.width / 2) - (1200 / 2); //Issue # 1697
	//var top = (screen.height / 2) - (200 / 2); //Issue # 1697
	//var newWin = window.open('', 'Print Page', 'height=auto,width=auto');
	// var newWin = window.open('', 'Print Page', 'width=' + 800 + ', height=' + 2000 + ', top=' + top + ', left=' + left + ''); //Issue # 1697
	// popupBlockerChecker.check(newWin);   //Issue # 1759
	// newWin.document.write('</head><body>');
	// newWin.document.write('<div id="SaleInvoice5Inch" style="width: 480px;height:auto">');
	var newWin = window.open(
		"",
		"Print Page",
		"width=" + 800 + ", height=" + 2000 + ""
	);
	newWin.document.write($("#" + ContainerId).html());
	// newWin.document.write('</div>');
	// newWin.document.write('</body></html>');
	newWin.document.close();
	setTimeout(function () {
		newWin.print();
		newWin.close();
	}, 250);
	//}
}
export const APILinks = {
	Login: BaseUrlAPI + "/token",
	ValidateSignUp: BaseUrlAPI + "/api/Landing/ValidateSignUp",
	SignUp: BaseUrlAPI + "/api/Landing/SignUp",
	RecoverPassword: BaseUrlAPI + "/api/Landing/RecoverPassword",
	ValidateRecoverPasswordToken:
		BaseUrlAPI + "/api/Landing/ValidateRecoverPasswordToken",
	ResetPassword: BaseUrlAPI + "/api/Landing/ResetPassword",
	SendContactMail: BaseUrlAPI + "/api/Landing/SendContactMail",
	UpdateUserProfile: BaseUrlAPI + "/api/Landing/UpdateProfile",
	ChangePassword: BaseUrlAPI + "/api/Landing/ChangePassword",

	SelectAll_Bank: BaseUrlAPI + "/api/Landing/SelectAllBank",
	Reset_PageLastSearch: BaseUrlAPI + "/api/Landing/ResetPageLastSearch",

	// Sync
	CheckServerResponse: BaseUrlAPI + "/api/Sync/CheckServerResponse",
	GetSyncConfigData: BaseUrlAPI + "/api/Sync/GetSyncConfigData",
	GetMaxEventId: BaseUrlAPI + "/api/Sync/GetMaxEventId",
	GetPendingEvents: BaseUrlAPI + "/api/Sync/GetPendingEvents",

	// Roles
	SelectAll_Role:
		BaseUrlAPI + "/api/roles/SelectAll?isPaginate=true&isFetchAdmin=true",
	SelectAll_RolesPermissions: BaseUrlAPI + "/api/roles/RolePermissions",
	Save_Role: BaseUrlAPI + "/api/roles/InsertRolePermissions",
	Delete_Role: BaseUrlAPI + "/api/roles/DeleteRole",
	Role_PermissionById: "/api/roles/RolePermissionById",
	Update_Role: BaseUrlAPI + "/api/Roles/Update",

	// Users
	SelectAll_UserRequests: BaseUrlAPI + "/api/User/SelectAllUserRequests",
	Delete_User: BaseUrlAPI + "/api/User/Delete",
	Reject_User: BaseUrlAPI + "/api/User/Reject",
	Approve_User: BaseUrlAPI + "/api/User/Approve",
	SelectAll_Users: BaseUrlAPI + "/api/User/SelectAll",
	Save_User: BaseUrlAPI + "/api/User/Save",
	Update_User: BaseUrlAPI + "/api/User/Update",
	Update_UserStatus: BaseUrlAPI + "/api/User/UpdateStatus",
	Select_User: BaseUrlAPI + "/api/User/SelectUser",
	SelectNonClustered_Rider: BaseUrlAPI + "/api/User/SelectNonClusteredRider",
	AddRemove_Microscope: BaseUrlAPI + "/api/Settings/UpdateMicroscope",
	Select_Microscope: BaseUrlAPI + "/api/Settings/SelectMicroscope",

	// District wise targets
	Select_DistrictWiseTargets: "/api/Settings/SelectDistrictWiseTargets",

	// Batches


	// Provinces
	SelectAll_Province: BaseUrlAPI + "/api/Province/SelectAll",
	Delete_Province: BaseUrlAPI + "/api/Province/Delete",
	Save_Province: BaseUrlAPI + "/api/Province/Save",
	Update_Province: BaseUrlAPI + "/api/Province/Update",

	// Districts
	SelectAll_District: BaseUrlAPI + "/api/District/SelectAll",
	Delete_District: BaseUrlAPI + "/api/District/Delete",
	Save_District: BaseUrlAPI + "/api/District/Save",
	Update_District: BaseUrlAPI + "/api/District/Update",
	All_Users: BaseUrlAPI + "/api/user/GetUsers",

	// SubRecipient
	SelectALl_SubRecipient: BaseUrlAPI + "/api/SubRecipient/SelectAll",
	Save_SubRecipient: BaseUrlAPI + "/api/SubRecipient/Save",
	Delete_SubRecipient: BaseUrlAPI + "/api/SubRecipient/Delete",
	Update_SubRecipient: BaseUrlAPI + "/api/SubRecipient/Update",

	// Tehsil
	SelectAll_Tehsil: BaseUrlAPI + "/api/Tehsil/SelectAll",
	Delete_Tehsil: BaseUrlAPI + "/api/Tehsil/Delete",
	Save_Tehsil: BaseUrlAPI + "/api/Tehsil/Save",
	Update_Tehsil: BaseUrlAPI + "/api/Tehsil/Update",

	// Xpert Sites
	SelectAll_XpertSites: BaseUrlAPI + "/api/XpertSite/SelectAll",
	Delete_XpertSites: BaseUrlAPI + "/api/XpertSite/Delete",
	Save_XpertSite: BaseUrlAPI + "/api/XpertSite/Save",
	Update_XpertSite: BaseUrlAPI + "/api/XpertSite/Update",
	SelectNonClustered_XpertSites:
		BaseUrlAPI + "/api/XpertSite/SelectNonClustered",

	// HCF
	SelectAll_HCF: BaseUrlAPI + "/api/HCF/SelectAll",
	GetAll_HCF: BaseUrlAPI + "/api/HCF/GetAll",
	SelectAll_HCF_New: BaseUrlAPI + "/api/HCF/SelectAll_New",
	Delete_HCF: BaseUrlAPI + "/api/HCF/Delete",
	Save_HCF: BaseUrlAPI + "/api/HCF/Save",
	Update_HCF: BaseUrlAPI + "/api/HCF/Update",
	SelectNonClustered_HCF: BaseUrlAPI + "/api/HCF/SelectNonClustered",
	SelectNonClustered_RHC: BaseUrlAPI + "/api/HCF/SelectNonClusteredRHC",
	UploadHCFFile: BaseUrlAPI + "/api/HCF/UploadHCFFile",

	// HCF Cluster
	SelectAll_HCFCluster: BaseUrlAPI + "/api/HCFCluster/SelectAll",
	Delete_HCFCluster: BaseUrlAPI + "/api/HCFCluster/Delete",
	Save_HCFCluster: BaseUrlAPI + "/api/HCFCluster/Save",
	Update_HCFCluster: BaseUrlAPI + "/api/HCFCluster/Update",
	Update_HCFClusterStatus: BaseUrlAPI + "/api/HCFCluster/UpdateClusterStatus",
	Select_HCFCluster: BaseUrlAPI + "/api/HCFCluster/SelectHCFCluster",
	SelectUnAssigned_Clusters:
		BaseUrlAPI + "/api/HCFCluster/SelectUnAssignedClusters",

	// Patients
	//SelectAll_Patients: BaseUrlAPI + "/api/Patients/SelectAll",
	SelectAll_Patients: BaseUrlAPI + "/api/Patients/SelectAllDistrictCheck",
	SelectAll_Patients_Download: BaseUrlAPI + "/api/Patients/SelectAllDistrictCheck_Download",
	Get_Patient: `${BaseUrlAPI}/api/Patients/GetPatient`,
	Delete_Patient: BaseUrlAPI + "/api/Patients/Delete",
	Save_Patient: BaseUrlAPI + "/api/Patients/Save",
	Update_Patient: BaseUrlAPI + "/api/Patients/Update",
	Update_PatientState: BaseUrlAPI + "/api/Patients/UpdatePatientState",
	Update_PatientDiagnosed: BaseUrlAPI + "/api/Patients/UpdatePatientDiagnosed",

	//Patient Samples
	SelectAll_PatientSamples_Old: BaseUrlAPI + "/api/PatientSamples/SelectAll",
	SelectAll_PatientSamples: BaseUrlAPI + "/api/PatientSamples/SelectAllDistrictCheck",
	SelectAll_PatientSamples_Download: BaseUrlAPI + "/api/PatientSamples/SelectAllDistrictCheck_Download",
	InsertQRIds: BaseUrlAPI + "/api/PatientSamples/InsertQRIds",
	InsertQRIdsXpert: BaseUrlAPI + "/api/PatientSamples/InsertQRIdsXpert",
	Delete_PatientSample: BaseUrlAPI + "/api/PatientSamples/Delete",
	Submit_PatientSample: BaseUrlAPI + "/api/PatientSamples/Submit",
	Submit_PatientSample_New: BaseUrlAPI + "/api/PatientSamples/SubmitWithPatient",
	Dispatch_PatientSample: BaseUrlAPI + "/api/PatientSamples/Dispatch",
	Receive_PatientSample: BaseUrlAPI + "/api/PatientSamples/Receive",
	Save_SampleResult: BaseUrlAPI + "/api/PatientSamples/SaveResult",
	Select_ScannedSample: BaseUrlAPI + "/api/PatientSamples/SelectScannedSampleToSubmit",
	Save_AfbResult: BaseUrlAPI + "/api/PatientSamples/SaveAfbResult",
	Save_AfbResult_Xpert: BaseUrlAPI + "api/PatientSamples/SaveAfbResultXpertSite",
	Update_SampleNegativeResultBypassStatus: BaseUrlAPI + "/api/PatientSamples/UpdateSampleNegativeResultBypassStatus",
	Update_SampleStatus: BaseUrlAPI + "/api/PatientSamples/UpdateSampleStatus",

	//Settings
	Save_Settings: BaseUrlAPI + "/api/Settings/Save",

	//Rider Feedback
	Save_RiderFeedback: BaseUrlAPI + "/api/RiderFeedback/Save",

	// Assignments
	Select_AllAssignments: BaseUrlAPI + "/api/Assignment/Select_All",
	Select_AllAssignmentsDownload: BaseUrlAPI + "/api/Assignment/Select_AllDownload",
	Select_BHUAssignments: BaseUrlAPI + "/api/Assignment/Select_BHUAssignments",
	Select_RHCAssignments: BaseUrlAPI + "/api/Assignment/Select_RHCAssignments",
	Select_DestinationAssignments:
		BaseUrlAPI + "/api/Assignment/SelectDestinationAssignments",
	ReActivate_Assignment: BaseUrlAPI + "/api/Assignment/ReGenerateAssignment",
	Select_RiderProfiles: BaseUrlAPI + "/api/Assignment/Select_RiderProfiles",
	Select_MultipleRiderProfiles: BaseUrlAPI + "/api/Assignment/Select_MultipleRiderProfiles",
	Select_MultipleRiderProfilesExport: BaseUrlAPI + "/api/Assignment/Select_MultipleRiderProfilesForExport",
	Select_RiderProfiles_withouDetails: BaseUrlAPI + "/api/Assignment/Select_RiderProf_Without_Details",
	Delete_Assignment: BaseUrlAPI + "/api/Assignment/Delete",

	// RiderIncentives
	RiderIncentives_SelectAll: BaseUrlAPI + "/api/RiderPayments/Incentives",
	RiderIncentives_SelectAll_Batches: BaseUrlAPI + "/api/RiderPayments/SelectAllBatches",

	// RiderPayments
	RiderPayments_SelectAll: BaseUrlAPI + "/api/RiderPayments/SelectAll",
	RiderPayments_BankUpload: BaseUrlAPI + "/api/RiderPayments/BankUpload",

	//HcfIncentives
	HcfIncentives_SelectAll: BaseUrlAPI + "/api/HcfPayments/Incentives",
	HcfIncentives_SelectAll_Batches: BaseUrlAPI + "/api/HcfPayments/SelectAllBatches",

	//HcfPayments
	HcfPayments_SelectAll: BaseUrlAPI + "/api/HcfPayments/SelectAll",
	HcfPayments_BankUpload: BaseUrlAPI + "/api/HcfPayments/BankUpload",

	// Dashboard
	Select_CradsStats: BaseUrlAPI + "/api/Dashboard/SelectCradsStats",
	Select_LineChartStats: BaseUrlAPI + "/api/Dashboard/SelectLineChartStats",
	Select_PieChartStats: BaseUrlAPI + "/api/Dashboard/SelectPieChartStats",
	Select_PieChartStatsEf: BaseUrlAPI + "/api/Dashboard/SelectPieChartStatsEf",
	Select_BarsChartStats: BaseUrlAPI + "/api/Dashboard/SelectBarsChartStats",
	SelectSubrecipientStats:
		BaseUrlAPI + "/api/Dashboard/SelectSubrecipientStats",

	TotalSamplesStats: BaseUrlAPI + "/api/Dashboard/TotalSamplesStats",
	SamplesAssignedToRiderStats:
		BaseUrlAPI + "/api/Dashboard/SamplesAssignedToRiderStats",
	TransportedSamplesStats:
		BaseUrlAPI + "/api/Dashboard/TransportedSamplesStats",
	TransportedAndTestedSamplesStats:
		BaseUrlAPI + "/api/Dashboard/TransportedAndTestedSamplesStats",
	AFB_PositiveCasesStats: BaseUrlAPI + "/api/Dashboard/AFBPositiveCasesStats",
	MTB_DetectedCasesStats: BaseUrlAPI + "/api/Dashboard/MTBDetectedCasesStats",
	RR_DetectedCasesStats: BaseUrlAPI + "/api/Dashboard/RRDetectedCasesStats",
	DistrictRidersCount: BaseUrlAPI + "/api/Dashboard/DistrictRidersCount",
	HCFCount: BaseUrlAPI + "/api/Dashboard/HCFCount",
	GXSitesCount: BaseUrlAPI + "/api/Dashboard/GXSitesCount",
	CostTransportedSample: BaseUrlAPI + "/api/Dashboard/CostTransportedSample",
	TurnArroundTime: BaseUrlAPI + "/api/Dashboard/TurnArroundTime",

	// Receive sms
	Collect_PatientSampleSMS: BaseUrlAPI + "/api/PatientSamples/CollectSampleSMS",
	Dispatch_PatientSampleSMS: BaseUrlAPI + "/api/PatientSamples/DispatchSMS",
	Save_SampleResultSMS: BaseUrlAPI + "/api/PatientSamples/SaveResultSMS",
	Submit_SampleWithPatientSMS:
		BaseUrlAPI + "/api/PatientSamples/SubmitWithPatient",
	Save_AfbResultSMS: BaseUrlAPI + "/api/PatientSamples/SaveAfbResultSMS",

	// Add administrator
	Add_Administrator: BaseUrlAPI + "/api/user/save",

	// Riders
	GetRiders: BaseUrlAPI + "/api/Rider/GetRiders",
	Sendtestsms: BaseUrlAPI + "/api/PushNotification/SendSMSTest",

	// Base
	GetActivityLog: BaseUrlAPI + "/api/Base/GetActivityLog",

	//Reports
	GetProvinceReport: `${BaseUrlAPI}/api/STProgressReport/STProgressReportProvince`,
	GetSrReport: `${BaseUrlAPI}/api/STProgressReport/STProgressReportSR`,
	GetDistrictReport: `${BaseUrlAPI}/api/STProgressReport/STProgressReportDistrict`,

	//Help Desk
	HelpDesk_List: `${BaseUrlAPI}/api/Helpdesk/get`,
	HelpDesk_Create: `${BaseUrlAPI}/api/Helpdesk/create`,
	HelpDesk_Delete: `${BaseUrlAPI}/api/Helpdesk`,
	HelpDesk_Edit: `http://localhost:44484/api/HelpDesk`,
	OpenDocument: `${BaseUrlAPI}`
};
export function Ajax(
	Token,
	type,
	isFormData,
	url,
	parameter,
	success_callback,
	error_callback
) {
	$.ajax({
		type: type,
		url: url,
		headers: { Authorization: "Bearer " + Token },
		async: true,
		data: parameter,
		traditional: true,
		contentType: isFormData ? false : "application/json",
		processData: !isFormData,
		success: (resp) => {
			if (success_callback && typeof success_callback === "function")
				success_callback(resp);
		},
		error: (error) => {
			// if (error_callback && typeof error_callback === "function")
			// error_callback(error);
		},
	});
}

export function makecurrencyformate(e) {
	var a = $("#" + e)
		.val()
		.toString()
		.replace(/,/g, "")
		.trim();
	$("#" + e).val(a.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
}
export function TryParseFloat(str, defaultValue) {
	var retValue = defaultValue === undefined ? 0 : defaultValue;
	if (str != null) str = str.toString().replace(/,/g, "").trim();
	if (isNaN(parseFloat(str)) === false) {
		retValue = parseFloat(str);
	}
	return retValue;
}
export function TryParseInt(str, defaultValue) {
	var retValue = defaultValue === undefined ? 0 : defaultValue;
	if (str != null) str = str.toString().replace(/,/g, "").trim();
	if (isNaN(parseFloat(str)) === false) {
		retValue = parseInt(str);
	}
	return retValue;
}
export function handlCustomeSimpleTabClick(e) {
	$(".Custome_simpleTabs_list li a").removeClass("active");
	$(".Custome_simpleTabs_list li a").removeClass("show");
	$(e.currentTarget).children().addClass("active show");
}
export function ConvertToCommaSplitArray(list, fieldId) {
	var temp = [];
	for (var i in list) {
		temp.push(list[i][fieldId]);
	}
	return temp;
}
export function GetIdsLabelString(
	listString,
	ProcessedArr,
	NameField = "name"
) {
	let IdList = listString.split(",");
	//console.log(IdList);
	IdList.shift();
	IdList.pop();
	let NameString = "";
	for (var i = 0; i < IdList.length; i++) {
		if (ProcessedArr[IdList[i]] !== undefined)
			NameString =
				NameString === ""
					? ProcessedArr[IdList[i]][NameField]
					: NameString + "," + ProcessedArr[IdList[i]][NameField];
	}
	let NamesList = NameString.split(",");
	if (NamesList.length > 2) {
		NameString =
			NamesList[0] + "," + NamesList[1] + " ... +" + (NamesList.length - 2);
	}

	return NameString;
}
export function compare(a, b) {
	if (a.name < b.name) {
		return -1;
	}
	if (a.name > b.name) {
		return 1;
	}
	return 0;
}

export function GetIdsCompleteLabelString(
	listString,
	ProcessedArr,
	NameField = "name"
) {
	let IdList = listString.split(",");
	IdList.shift();
	IdList.pop();
	let NameString = "";
	for (var i = 0; i < IdList.length; i++) {
		if (ProcessedArr[IdList[i]] !== undefined)
			NameString =
				NameString === ""
					? ProcessedArr[IdList[i]][NameField]
					: NameString + "," + ProcessedArr[IdList[i]][NameField];
	}
	return NameString;
}
export function GetPastSubtractedDate(dateVal, days) {
	var date = new Date(dateVal);
	var last = new Date(date.getTime() - days * 24 * 60 * 60 * 1000);
	var day = last.getDate();
	var month = last.getMonth() + 1;
	var year = last.getFullYear();
	return new Date(month + "/" + day + "/" + year);
}
export function GetWeekDaysDate(d, day) {
	let arr = {
		Sunday: 0,
		Monday: 1,
		Tuesday: 2,
		Wednesday: 3,
		Thursday: 4,
		Friday: 5,
		Saturday: 6,
	};
	var curr = new Date(d); // get current date
	var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
	var last = first + arr[day]; // last day is the first day + 6
	var caldate = new Date(curr.setDate(last));
	return new Date(new Date(caldate).setHours(0, 0, 0, 0));
}
export function GetDateMonthViewDate(date) {
	const monthNames = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];
	var DateTemp = new Date(date);
	var day = ("0" + DateTemp.getDate()).slice(-2);
	var monthlabel = monthNames[DateTemp.getMonth()];
	return day + " " + monthlabel;
}
export function get24hrtime(time) {
	var time = time;
	var hours = Number(time.match(/^(\d+)/)[1]);
	var minutes = Number(time.match(/:(\d+)/)[1]);
	var AMPM = time.match(/\s(.*)$/)[1];
	if (AMPM === "PM" && hours < 12) hours = hours + 12;
	if (AMPM === "AM" && hours === 12) hours = hours - 12;
	var sHours = hours.toString();
	var sMinutes = minutes.toString();
	if (hours < 10) sHours = "0" + sHours;
	if (minutes < 10) sMinutes = "0" + sMinutes;
	return sHours + ":" + sMinutes;
}

export function get12hrTime(time) {
	// Check correct time format and split into components
	time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
		time,
	];

	if (time.length > 1) {
		// If time format correct
		time = time.slice(1); // Remove full string match value
		time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
		time[0] = +time[0] % 12 || 12; // Adjust hours
	}
	return time.join(""); // return adjusted time or original string
}
